import { render, staticRenderFns } from "./WorkerForm.vue?vue&type=template&id=9835b02c&scoped=true"
import script from "./WorkerForm.vue?vue&type=script&lang=ts"
export * from "./WorkerForm.vue?vue&type=script&lang=ts"
import style0 from "./WorkerForm.vue?vue&type=style&index=0&id=9835b02c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9835b02c",
  null
  
)

export default component.exports